import script from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=ef94ecc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef94ecc6"]])

export default __exports__